module.exports = __webpack_public_path__ + "static/media/Oliva-Serif-Alts-2.d8e03979.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oliva-Serif-Alts-2.woff
// module id = 3468
// module chunks = 70